var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                { staticClass: "col-md-12" },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c("StepTitle", [
                        _vm._v("Asociar Cliente Proveedor de GPS")
                      ]),
                      _c("v-divider"),
                      _c("CabeceraTabla", {
                        scopedSlots: _vm._u([
                          {
                            key: "izquierda",
                            fn: function() {
                              return [
                                _c("BuscadorOperacionCrud", {
                                  attrs: {
                                    filter:
                                      _vm.gridApi &&
                                      _vm.gridApi.setQuickFilter.bind(
                                        _vm.gridApi
                                      )
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _vm.modoVer
                            ? _c("MantenedorGridVerDetalle", {
                                attrs: {
                                  "grid-options": _vm.computedGridOptions
                                }
                              })
                            : _c("AsociacionGrid", {
                                attrs: {
                                  "grid-options": _vm.computedGridOptions,
                                  esEditar: _vm.esEditar
                                }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("MensajeValidacion", {
        attrs: {
          showDialog: _vm.showValidacion,
          titulo: _vm.$t(_vm.tituloValidacion),
          mensaje: _vm.$t(_vm.mensajeValidacion)
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.showValidacion = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }